import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useLanguage } from "@/contexts/LanguageContext";

const CookieBanner = () => {
  const { showBanner, accept, decline } = useCookieConsent();
  const { t } = useLanguage();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-ink-900/95 backdrop-blur-sm text-white p-4 md:p-6 shadow-lg border-t border-white/[0.06]">
      <div className="container mx-auto flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm flex-1">
          {t("cookie.text")}{" "}
          <Link to="/datenschutz" className="underline hover:text-violet transition-colors">
            {t("cookie.learnMore")}
          </Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <Button onClick={decline} variant="ghost" className="rounded-full border border-white/30 !text-white hover:!text-white hover:bg-white/10">
            {t("cookie.decline")}
          </Button>
          <Button onClick={accept} className="btn-violet">
            {t("cookie.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
